// Import components
import './Admindashboard.css';
import React, { useMemo, useState,useEffect } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import {  Card, CardBody, Row, Col,Nav,NavItem,NavLink, TabContent, TabPane,Modal, ModalHeader, Alert } from 'reactstrap';
import classnames from "classnames";
import axios from 'axios';
interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}


const RecycleBinManagement = () => {
    const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    const [domainData, setDomainData] = useState([]);
    const [SubdomainData, setSubDomainData] = useState([]);
    const [selectedDomainId, setSelectedDomainId] = useState<number | null>(null);
    const [selectedsubDomainId, setSelectedsubDomainId] = useState<number | null>(null);






    const fetch_Domain = async () => {
        try{
            const response = await axios.post('/accounts/handleadmhiddendomains',)
            if (response.status === "SENT"){
                setDomainData(response.domains);
                // const allSubdomains = response.domains.flatMap((domain: any) =>
                //     (domain.navsubdomains || []).map((sub: any) => ({
                //         Did:domain.id,
                //         domainName: domain.name,
                //         subdomainName: sub.name,
                //         id: sub.id,
                //     }))
                // );
                // console.log('allSubdomains',allSubdomains)
                setSubDomainData(response.Subdom);
                // setSubDomainData(response.Subdom);
            }
    
        }catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment', error.response.error, error.response)
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
        // setshowloader(false)
        }
    }
    
    
    
    
    
    const domaincolumns: column[] = useMemo(
        () => [
            {
                header: 'S.No',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => row.index + 1,
            },
            {
                header: 'Domain Name',
                accessorKey: 'name',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => {
                    const recycledata = row.original;
    
                    return (
                        <div>
                            <div className="fw-medium">{recycledata.name}</div>
                        </div>
                    );
                },
            },
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({row }) => (
                    <div className="d-flex gap-2">
                        <button className="btn btn-soft-primary btn-sm" title="Click to Restore" onClick={() => {
                        restore_domain(row.original.id);
                        }} >
                            <i className="bx bx-sync font-size-14 align-middle"></i>
                            Restore Domain
                        </button>
                        <button className="btn btn-soft-danger btn-sm" title="Delete Permanent" onClick={() => {
                            setSelectedDomainId(row.original.id);
                            delete_domain();
                        }}>
                            <i className="bx bx-x  font-size-14 align-middle"></i>
                            Delete Permanent
                        </button>
                    </div>
                ),
            }
        ],
        []
    );

    const subdomaincolumns: column[] = useMemo(
        () => [
            {
                header: 'S.No',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => row.index + 1,
            },

            // {
            //     header: 'Did --- SDid',
            //     enableColumnFilter: false,
            //     enableSorting: false,
            //     cell: ({ row }) =>  (<>{row.original.id}</>),
            // },
            // {
            //     header: 'Domain',
            //     enableColumnFilter: false,
            //     enableSorting: true,
            //     cell: ({ row }) => row.original.domainName,
            // },
            {
                header: 'Sub Domain',
                accessorKey: 'name',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => row.original.name,
            },
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => (
                    <div className="d-flex gap-2">
                        <button
                            className="btn btn-soft-primary btn-sm"
                            title="Click to Restore"
                            onClick={() => restore_Subdomain(row.original.id)}
                        >
                            <i className="bx bx-sync font-size-14 align-middle"></i>
                            Restore Sub Domain
                        </button>
                        <button
                            className="btn btn-soft-danger btn-sm"
                            title="Delete Permanent"
                            onClick={() => {
                                setSelectedsubDomainId(row.original.id)
                                delete_sub_domain()
                            }}
                        >
                            <i className="bx bx-x font-size-14 align-middle"></i>
                            Delete Permanent
                        </button>
                    </div>
                ),
            }
        ],
        []
    );


    const [verticalActiveTab, setverticalActiveTab] = useState("1");
    const [modal_standard_domain, setmodal_standard] = useState(false);
    const [modal_standard_subdomain, setmodal_standard_sub] = useState(false);

    function delete_domain() {
        setmodal_standard(!modal_standard_domain);
        removeBodyCss();
    }

    const permanent_delete_domain = async () => {
        if (selectedDomainId) {
            try{
                const isDomain = "true";
                console.log('isDomain', isDomain)
                console.log('dom_id', selectedDomainId)
                const response = await axios.post(`accounts/handleadmdomains`, {
                    action: "permanent_delete",
                    isdom: isDomain,
                    did: selectedDomainId,
                });
            
                if (response.status === "DONE") {
                    setmodal_standard(false)
                    fetch_Domain();
                }
            } catch (error:any) {
                if (error.response) {
                    if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
                    else if (error.response.status === 403) {
                        setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                        setTimeout(()=>{window.location.href="/logout"}, 2000)
                    } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
                } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
                // setshowloader(false);
            }
        }
    }

    const restore_domain = async (dom_id:any) => {
        try{
            const isDomain = "true";
            console.log('isDomain', isDomain)
            console.log('dom_id', dom_id)
            const response = await axios.post(`accounts/handleadmdomains`, {
                action: "restore",
                isdom: isDomain,
                did: dom_id,
            });
        
            if (response.status === "DONE") {
                fetch_Domain();
            }
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
                else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
            } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
            // setshowloader(false);
        }
    }

    const permanent_delete_subdomain = async () => {
        if (selectedsubDomainId) {
            try{
                const isDomain = "false";
                console.log('isDomain', isDomain)
                console.log('dom_id', selectedsubDomainId)
                const response = await axios.post(`accounts/handleadmdomains`, {
                    action: "permanent_delete",
                    isdom: isDomain,
                    sdid: selectedsubDomainId,
                });
            
                if (response.status === "DONE") {
                    setmodal_standard_sub(false)
                    fetch_Domain();
                }
            } catch (error:any) {
                if (error.response) {
                    if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
                    else if (error.response.status === 403) {
                        setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                        setTimeout(()=>{window.location.href="/logout"}, 2000)
                    } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
                } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
                // setshowloader(false);
            }
        }
    }

    const restore_Subdomain = async (Sdom_id:Number) =>{
        try{
            const isDomain = "false";
            console.log('isDomain', isDomain)
            console.log('Sdom_id', Sdom_id)
            const response = await axios.post(`accounts/handleadmdomains`, {
                action: "restore",
                isdom: isDomain,
                sdid:Sdom_id,
            });
        
            if (response.status === "DONE") {
                fetch_Domain();
            }
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
                else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
            } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
            // setshowloader(false);
        }
    }


    function delete_sub_domain() {
        setmodal_standard_sub(!modal_standard_subdomain);
        removeBodyCss();
    }
    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }
    


    const toggleVertical = (tab: any) => {
        if (verticalActiveTab !== tab) {
        setverticalActiveTab(tab);
        }
    };

    useEffect(() => {
        fetch_Domain();
    },[]);
    

    document.title = "Recycle | BizServe";

    return (
        <div className="page-content">
            <div className="container-fluid">
                {alertMsgg.open && (
                    <Alert
                        color={alertMsgg.type === "success" ? "success" : "danger"}
                        toggle={handleAlertMsggClose}
                        style={{ fontWeight: "bold" }}
                        >
                        {alertMsgg.content}
                    </Alert>
                )}
                <Breadcrumbs title="Admin" breadcrumbItem="Recycle" />
                
                <Row>
                    <Col md="2">
                        <Nav pills className="flex-column">
                            <NavItem>
                                <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                    "mb-2": true,
                                    active: verticalActiveTab === "1",
                                })}
                                onClick={() => {
                                    toggleVertical("1");
                                }}
                                >
                                Domains
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink style={{ cursor: "pointer" }} className={classnames({"mb-2": true, active: verticalActiveTab === "2",})}
                                onClick={() => {toggleVertical("2");}}
                                >
                                Sub-Domains
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Col>
                    <Col md="10">
                        <TabContent
                        activeTab={verticalActiveTab}
                        className="text-muted mt-4 mt-md-0"
                        >
                            <TabPane tabId="1">
                                <Card className="rounded-4 border">
                                    <CardBody>
                                        <div className="mb-4">
                                            <h5 className="text-danger">Deleted Domains</h5>
                                            <p >You can restore domains from here.</p>
                                        </div>
                                            {domainData && domainData.length > 0 ? (
                                                <TableContainer
                                                    columns={domaincolumns}
                                                    data={domainData || []}
                                                    isGlobalFilter={true}
                                                    isPagination={true}
                                                    SearchPlaceholder="Search By Name..."
                                                    pagination="pagination"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers"
                                                    tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                />
                                            ) : (
                                                <div className="text-center py-4 fw-semibold text-muted">No Domain</div>
                                            )}
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId="2">
                                <Card className="rounded-4 border">
                                    <CardBody>
                                        <div className="mb-4">
                                            <h5 className="text-danger">Deleted Sub-Domains</h5>
                                            <p >You can restore sub-domains from here.</p>
                                        </div>
                                        {SubdomainData && SubdomainData.length > 0 ? (
                                            <TableContainer
                                                columns={subdomaincolumns}
                                                data={SubdomainData || []}
                                                isGlobalFilter={true}
                                                isPagination={true}
                                                SearchPlaceholder="Search By Name..."
                                                pagination="pagination"
                                                paginationWrapper='dataTables_paginate paging_simple_numbers'
                                                tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                            />
                                        ) : (
                                            <div className="text-center py-4 fw-semibold text-muted">No Sub Domain</div>
                                        )}
                                    </CardBody>
                                </Card>
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
                <Modal
                    isOpen={modal_standard_domain}
                    toggle={() => {delete_domain();}}
                    centered
                    className="rounded-4"
                >
                <ModalHeader className="py-3 px-4" toggle={() => {delete_domain();}}>
                    <div className="modal-title mt-0 font-size-16 text-dark">
                    Delete Domain Permanent
                    </div>
                </ModalHeader>
                
                <div className="modal-body">
                    <p>Are you sure you want to delete this domain for permanent?</p>
                </div>
                
                <div className="modal-footer">
                    <button 
                    type="button" 
                    className="btn btn-sm btn-soft-dark" 
                    onClick={() => {delete_domain();}}
                    >
                    Cancel
                    </button>
                    
                    <button 
                    type="button" 
                    className="btn btn-sm btn-danger" 
                    onClick={() => {permanent_delete_domain();}}
                    >
                    Delete
                    </button>
                </div>
                </Modal>



                <Modal
                    isOpen={modal_standard_subdomain}
                    toggle={() => {delete_sub_domain();}}
                    centered
                    className="rounded-4"
                >
                    <ModalHeader className="py-3 px-4" toggle={() => {delete_sub_domain();}}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                        Delete Sub Domain Permanent
                        </div>
                    </ModalHeader>
                    
                    <div className="modal-body">
                        <p>Are you sure you want to delete this sub domain for permanent?</p>
                    </div>
                    
                    <div className="modal-footer">
                        <button 
                        type="button" 
                        className="btn btn-sm btn-soft-dark" 
                        onClick={() => {delete_sub_domain();}}
                        >
                        Cancel
                        </button>
                        <button 
                        type="button" 
                        className="btn btn-sm btn-danger" 
                        onClick={() => {permanent_delete_subdomain()}}
                        >
                        Delete
                        </button>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default RecycleBinManagement;
